import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';
import './SurveyLibraryUpdateContainer.scss';
import { withRouter } from 'react-router-dom';
import { array, bool, func, number, object, shape, string } from 'prop-types';
import MarketPaySurveyLibrary from './MarketPaySurveyLibrary/MarketPaySurveyLibrary';
import { marketPaySurveyLibrarySearchActions } from './MarketPaySurveyLibrary/facet/MarketPaySurveyLibraryFacet';
import SurveyLibraryChangeRequest from './SurveyLibraryChangeRequest/SurveyLibraryChangeRequest';
import * as surveyLibraryChangeActionCreators from './SurveyLibraryChangeActions';
import { initializeAgreement, setSubmitStatus } from './Agreement/SLUAgreementActions';
import { showSlideout, hideSlideout } from 'ps-components/Slideout/SlideoutReducer';

function SurveyLibraryUpdateContainer(props) {
  const tabPaths = ['marketpay-library', 'change-request'];
  const MARKETPAY_LIBRARY_TAB = 0;
  const SURVEY_LIBRARY_CHANGE_REQUEST_TAB = 1;

  const [selectedTabIndex, setSelectedTabIndex] = useState(MARKETPAY_LIBRARY_TAB);

  useEffect(() => {
    props.actions.getPendingSurveyRequests();
  }, []);

  goToTab();

  function goToTab() {
    const tabIndex = tabPaths.indexOf(props.match.params.tab);
    if (tabIndex === -1) {
      props.history.push('/');
    } else if (tabIndex !== selectedTabIndex) {
      setSelectedTabIndex(tabIndex);
    }
  }

  function getTabs() {
    const tabs = ['MarketPay Survey Library'];
    // Update later on to allow a count next to Survey Library Change Request label
    let changeRequestTabName = 'Survey Library Change Request';
    if (props.pendingSurveyRequests.length > 0) {
      changeRequestTabName += ` (${props.pendingSurveyRequests.length})`;
    }
    tabs.push(changeRequestTabName);
    return tabs;
  }

  function switchTab(tab) {
    if (tab !== selectedTabIndex) {
      setSelectedTabIndex(tab);
      const tabPath = tabPaths[tab];
      props.history.push(`/market-analysis/survey-library/${tabPath}`);
    }
  }

  function addSurveys(surveys) {
    const surveysToAdd = surveys.map(survey => {
      return { surveyCode: survey.code, surveyName: survey.name };
    });
    return props.actions.addSurveys(surveysToAdd).then(() => {
      switchTab(SURVEY_LIBRARY_CHANGE_REQUEST_TAB);
    });
  }

  const { marketPaySurveyLibrarySearch, actions } = props;
  return (
    <div className="survey-library-update__container">
      <div className="survey-library-update__header">
        <div className="survey-library-update__title">Survey Library Change</div>
        <ViewSwitcher
          isSticky={true}
          className={'survey-library-update__view-switcher'}
          tabList={getTabs()}
          activeTab={selectedTabIndex}
          tabSwitch={switchTab}
        />
      </div>
      <div className="market-pricing__tab-panel">
        {selectedTabIndex === MARKETPAY_LIBRARY_TAB && (
          <MarketPaySurveyLibrary
            marketPaySurveyLibrarySearch={marketPaySurveyLibrarySearch}
            searchInputSearch={actions.searchInputSearch}
            facetItemClick={actions.facetItemClick}
            facetReset={actions.facetReset}
            onSurveyAdd={addSurveys}
            pendingSurveyRequests={props.pendingSurveyRequests}
            isRetrievingPendingSurveys={props.isRetrievingPendingSurveys}
            pageList={actions.pageList}
            handleReset={actions.handleReset}
            isRetrievingPublishers={props.isRetrievingPublishers}
            isRetrievingPublishersError={props.isRetrievingPublishersError}
            getPublishers={props.actions.getPublishers}
            publishers={props.publishers}
            selectedPublisher={props.selectedPublisher}
            setSelectedPublisher={props.actions.setSelectedPublisher}
            setNewSurveyName={props.actions.setNewSurveyName}
            newSurveyName={props.newSurveyName}
            isAddingSurveys={props.isAddingSurveys}
            hasAddSurveysError={props.hasAddSurveysError}
            history={props.history}
            resetAddSurveysError={props.actions.resetAddSurveysError}
          />
        )}
        {selectedTabIndex === SURVEY_LIBRARY_CHANGE_REQUEST_TAB && (
          <SurveyLibraryChangeRequest
            getAuditTrail={props.actions.getAuditTrail}
            setOffset={props.actions.setOffset}
            offset={props.offset}
            limit={props.limit}
            totalCount={props.totalCount}
            auditTrails={props.auditTrails}
            pendingSurveyRequests={props.pendingSurveyRequests}
            isDeletingSurveyRequest={props.isDeletingSurveyRequest}
            hasDeleteSurveyRequestError={props.hasDeleteSurveyRequestError}
            deleteSurveyRequest={props.actions.deleteSurveyRequest}
            subscribeSurveys={props.actions.subscribeSurveys}
            initializeAgreement={props.actions.initializeAgreement}
            showSlideout={props.actions.showSlideout}
            hideSlideout={props.actions.hideSlideout}
            setSubmitStatus={props.actions.setSubmitStatus}
            updateSurvey={props.actions.updateSurvey}
            updatePendingSurvey={props.actions.updatePendingSurvey}
            resetDeleteSurveyError={props.actions.resetDeleteSurveyError}
            hasSubGroups={props.groups?.length > 1}
          />
        )}
      </div>
    </div>
  );
}

SurveyLibraryUpdateContainer.propTypes = {
  history: object,
  match: object,
  actions: shape({
    getAuditTrail: func,
    setOffset: func,
    getPendingSurveyRequests: func,
    addSurveys: func,
    deleteSurveyRequest: func,
    facetReset: func,
    facetItemClick: func,
    searchInputSearch: func,
    pageList: func,
    getPublishers: func,
    setSelectedPublisher: func,
    setNewSurveyName: func,
    subscribeSurveys: func,
    initializeAgreement: func,
    showSlideout: func,
    hideSlideout: func,
    updateSurvey: func,
    updatePendingSurvey: func,
    resetAddSurveysError: func,
    resetDeleteSurveyError: func,
    handleReset: func
  }),
  getAuditTrailError: bool,
  getAuditTrailLoading: bool,
  auditTrails: array,
  offset: number,
  limit: number,
  totalCount: number,
  pendingSurveyRequests: array,
  isRetrievingPendingSurveys: bool,
  isDeletingSurveyRequest: bool,
  hasDeleteSurveyRequestError: bool,
  publishers: array,
  isRetrievingPublishers: bool,
  isRetrievingPublishersError: bool,
  selectedPublisher: string,
  newSurveyName: string,
  isAddingSurveys: bool,
  hasAddSurveysError: bool,
  hasSubGroups: bool
};

const mapStateToProps = ({ marketPaySurveyLibrarySearch, surveyLibraryChange, groups }) => ({
  ...surveyLibraryChange,
  marketPaySurveyLibrarySearch,
  groups
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...surveyLibraryChangeActionCreators,
      ...marketPaySurveyLibrarySearchActions,
      initializeAgreement,
      setSubmitStatus,
      hideSlideout,
      showSlideout
    },
    dispatch
  )
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SurveyLibraryUpdateContainer));
